export interface UploadPart {
  /** 1-based, as S3/R2 number them. */
  partNumber: number;
  /** Byte offset, inclusive. */
  start: number;
  /** Byte offset, exclusive. */
  end: number;
}

/** Split `size` bytes into consecutive parts of `partSize` (the last may be shorter). */
export function planUploadParts(size: number, partSize: number): UploadPart[] {
  if (partSize <= 0) throw new Error('partSize must be positive');
  const parts: UploadPart[] = [];
  for (let start = 0, partNumber = 1; start < size; start += partSize, partNumber++) {
    parts.push({ partNumber, start, end: Math.min(size, start + partSize) });
  }
  return parts.length > 0 ? parts : [{ partNumber: 1, start: 0, end: 0 }];
}

/** How many parts a file of `size` needs. */
export const uploadPartCount = (size: number, partSize: number): number =>
  Math.max(1, Math.ceil(size / partSize));
